module.exports = __webpack_public_path__ + "img/thermometer_White.b4c9a283.svg";